define(function (require, exports, module) {
    var subsList = [];

    function subsLoop (datasource, index) {
        if (datasource) {
            subsList.push(datasource);
        }
    }

    function ensureSources (srcs) {
        return (Array.isArray(srcs) ? srcs : [srcs]);
    }

    exports.establishInitSubscribes = function (srcs) {
        ensureSources(srcs).forEach(subsLoop);
    };

    exports.getSubscriptions = function () {
        return subsList;
    };
});
